module.exports = __webpack_public_path__ + "static/bootstrap-toast-42dd54aaa231ba4d044e49e8297a8a52.png";